import { Card, CardContent, Separator } from '@parrot-software/design-system';

interface ReferralStepProps {
  number: string;
  tag: string;
  tagAmount?: string;
  text: string;
}

/**
 * Single "Cómo funciona" step rendered in a design-system Card: ordinal, description and a
 * footer tag. Step three also shows a trailing amount aligned to the right of the tag.
 *
 * @param {ReferralStepProps} props - Component properties
 * @returns {React.ReactElement} The step card
 */
export const ReferralStep = ({ number, tag, tagAmount, text }: ReferralStepProps) => (
  <Card className="h-full">
    <CardContent className="flex h-full flex-col gap-4 p-5">
      <div className="flex gap-3">
        <span className="text-sm font-bold text-primary">{number}</span>
        <p className="text-sm font-medium text-foreground">{text}</p>
      </div>

      <div className="mt-auto flex flex-col gap-3">
        <Separator />
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">{tag}</span>
          {tagAmount ? <span className="text-xs font-semibold text-foreground">{tagAmount}</span> : null}
        </div>
      </div>
    </CardContent>
  </Card>
);
